import {
  B2C_KNOWN_AUTHORITY,
  B2C_CLIENT_ID,
  B2C_SCOPE,
  B2C_AUTHORITY_URL,
} from '../src/config/environment';

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig = {
  auth: {
    clientId: B2C_CLIENT_ID,
    authority: B2C_AUTHORITY_URL,
    knownAuthorities: [B2C_KNOWN_AUTHORITY],
    postLogoutRedirectUri: '/',
    redirectUri: window.location.origin,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
};

export const loginRequest = {
  scopes: [B2C_SCOPE],
};
